import React, { useEffect, useState } from 'react';
import { ShoppingCartIcon, ArrowRightIcon } from 'lucide-react';
import { handleCheckoutMegapack } from '../utils/checkout';
import { PRICING } from '../data/landing';
const TOTAL_SECONDS = 12 * 60;
const STORAGE_KEY = 'nerovix_offer_end';
function useCountdown(): string {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    const end = stored ? parseInt(stored, 10) : Date.now() + TOTAL_SECONDS * 1000;
    if (!stored) {
      sessionStorage.setItem(STORAGE_KEY, String(end));
    }
    const tick = () => {
      setRemaining(Math.max(0, Math.round((end - Date.now()) / 1000)));
    };
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
function useVisibleAfter(targetId: string): boolean {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const evaluate = () => {
      const target = document.getElementById(targetId);
      if (!target) return;
      setVisible(target.getBoundingClientRect().top <= window.innerHeight * 0.85);
    };
    evaluate();
    window.addEventListener('scroll', evaluate, {
      passive: true
    });
    window.addEventListener('resize', evaluate);
    return () => {
      window.removeEventListener('scroll', evaluate);
      window.removeEventListener('resize', evaluate);
    };
  }, [targetId]);
  return visible;
}
export function StickyCTABar() {
  const time = useCountdown();
  const visible = useVisibleAfter('sticky-cta-anchor');
  return <div className={`fixed bottom-0 left-0 right-0 z-50 border-t border-gold/25 bg-carbon/95 backdrop-blur-sm transition-transform duration-200 ease-out ${visible ? 'visible translate-y-0' : 'invisible pointer-events-none translate-y-full'}`} data-id="element-171" data-mp="3qd0aa0g9ej12">
      <div className="mx-auto max-w-[1080px] px-3 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-1.5 sm:px-5" data-id="element-172" data-mp="2xahbna0ts17w">
        <div className="flex items-center justify-between gap-2" data-id="element-173" data-mp="2sho98sstx4yz">
          <div className="flex min-w-0 items-center gap-1.5" data-id="element-174" data-mp="2nkxv4b0l4jg7">
            <span className="h-1.5 w-1.5 flex-none rounded-full bg-gold" aria-hidden="true" data-id="element-175" data-mp="2ikte8jvrlmpg" />
            <span className="truncate text-[8.5px] font-medium uppercase tracking-[0.12em] text-ink-light/50" data-id="element-176" data-mp="3g8tmd07dxj5l">
              Precio de lanzamiento por tiempo limitado
            </span>
            <span className="flex-none rounded-[4px] bg-gold/15 px-1.5 py-[1px] text-[10px] font-bold tabular-nums text-gold-light" data-id="element-177" data-mp="369unuagc33wb">
              {time}
            </span>
          </div>
          <span className="flex-none text-[9.5px] font-bold uppercase tracking-[0.08em] text-gold-light" data-id="element-178" data-mp="1uuz2y6r3g67b">
            Ahorras {PRICING.savings}
          </span>
        </div>

        <button type="button" onClick={handleCheckoutMegapack} style={{
        backgroundImage: 'linear-gradient(100deg, #C99A4A 0%, #8E6A3C 38%, #4A3038 72%, #2E1F33 100%)'
      }} className="group mt-1.5 flex w-full items-center gap-2.5 rounded-[10px] px-3 py-2 text-left transition-[filter] duration-150 ease-out hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-light focus-visible:ring-offset-2 focus-visible:ring-offset-carbon" data-id="element-179" data-mp="1pygzda7i2dwk">
          <ShoppingCartIcon className="h-4 w-4 flex-none text-carbon" aria-hidden="true" data-id="element-180" data-mp="t2mqoqxnu37o" />
          <span className="min-w-0 flex-1" data-id="element-181" data-mp="y3k5qundih4y">
            <span className="block truncate text-[8px] font-bold uppercase tracking-[0.14em] text-carbon/70" style={{
            fontSize: "10px"
          }} data-id="element-182" data-mp="131lo1dcz6cfd">
              Mega Pack Hombre Magnético
            </span>
            <span className="block text-[13px] font-extrabold leading-tight text-carbon" style={{
            fontSize: "14px"
          }} data-id="element-183" data-mp="34sypttjnc477">
              Adquirir ahora
            </span>
          </span>
          <span className="flex flex-none items-center gap-1.5" data-id="element-184" data-mp="u5tvlzqwg3h3">
            <span className="text-[10px] font-medium text-ink-light/55 line-through" data-id="element-185" data-mp="u5bt4ldn8t0q">
              {PRICING.previous}
            </span>
            <span className="text-[15px] font-extrabold text-ink-light" style={{
            fontSize: "16px"
          }} data-id="element-186" data-mp="14417w5a8txcr">
              {PRICING.current}
            </span>
            <ArrowRightIcon className="h-3.5 w-3.5 text-ink-light/70 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-187" data-mp="geyi2a5ggy76" />
          </span>
        </button>
      </div>
    </div>;
}